// Иконка кнопки слоев поля (VisualToggles) — она же в тексте правил
export const VISUAL_TOGGLES_ICON = '/img/icons/layers.png';
